<template>
    <div>
        <div class="form__split form__split-nopb _pt-0">
            <div class="form__split-half">
                <div class="h3">Укажите персональные данные</div>
            </div>
            <div class="form__split-half _mt-0-16">
                <div>
                    <div class="form__row">
                        <div class="form__col">
                            <ui-form-field
                                label="Фамилия"
                                :errors="vuelidateErrorMesages['lastName']"
                                id="cards-form-last_name"
                                :value="$v.lastName.$model"
                            >
                                <template v-slot:default="{ id, errors }">
                                    <UiTextInputSuggestions
                                        :id="id"
                                        :error="!!errors.length"
                                        v-model="$v.lastName.$model"
                                        name="lastName"
                                        :suggestionType="ESuggestionTypes.NAME"
                                        :suggestionPatrs="[EFioParts.SURNAME]"
                                    />
                                </template>
                            </ui-form-field>
                        </div>
                        <div class="form__col">
                            <ui-form-field
                                label="Имя"
                                :errors="vuelidateErrorMesages['firstName']"
                                id="cards-form-first_name"
                                :value="$v.firstName.$model"
                            >
                                <template v-slot:default="{ id, errors }">
                                    <UiTextInputSuggestions
                                        :id="id"
                                        :error="!!errors.length"
                                        v-model="$v.firstName.$model"
                                        name="firstName"
                                        :suggestionType="ESuggestionTypes.NAME"
                                        :suggestionPatrs="[EFioParts.NAME]"
                                    />
                                </template>
                            </ui-form-field>
                        </div>
                    </div>
                    <div class="form__row">
                        <div class="form__col">
                            <ui-form-field
                                label="Отчество"
                                :errors="vuelidateErrorMesages['middleName']"
                                id="cards-form-middle_name"
                                :value="$v.middleName.$model"
                            >
                                <template v-slot:default="{ id, errors }">
                                    <UiTextInputSuggestions
                                        :id="id"
                                        :error="!!errors.length"
                                        v-model="$v.middleName.$model"
                                        :disabled="hasntMiddleName"
                                        name="middleName"
                                        :suggestionType="ESuggestionTypes.NAME"
                                        :suggestionPatrs="[EFioParts.PATRONYMIC]"
                                    />
                                </template>
                            </ui-form-field>
                        </div>
                        <div class="form__col _align-self-center">
                            <div @click="hasntMiddleName = !hasntMiddleName" class="checkbox checkbox-vcenter _mt-0 _mb-0">
                                <input v-model="hasntMiddleName" type="checkbox" class="checkbox__input">
                                <label class="checkbox__label">
                                    <p class="p2">Нет отчества</p>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="form__row">
                        <div class="form__col _mb-0-24">
                            <div class="form__item form__item-wide _mb-0">
                                <div class="form__input date-input _focus" :class="{'_invalid': $v.birthDate.$error || !$v.birthDate.ageRange}">
                                    <ui-form-field
                                        label="Дата рождения"
                                        :value="$v.birthDate.$model"
                                    >
                                        <template v-slot:default="{ id, errors }">
                                            <ui-date-picker
                                                :id="id"
                                                v-model="$v.birthDate.$model"
                                                :error="errors.length > 0"
                                            />
                                        </template>
                                    </ui-form-field>
                                </div>
                            </div>
                            <p class="form-error" v-if="$v.birthDate.$error && !$v.birthDate.required">Поле обязательно для заполнения</p>
                            <p class="form-error" v-if="$v.birthDate.$error || !$v.birthDate.ageRange">Возраст должен быть больше 18 лет</p>
                        </div>

                        <div class="form__col">
                            <div class="form__item form__item-wide">
                                <DInput
                                    v-model.trim="$v.phone.$model"
                                    label="Телефон"
                                    name="phone"
                                    placeholder="+7"
                                    inputmode="tel"
                                    :error="$v.phone.$error || phoneStartsAtEight"
                                    type="tel"
                                    v-mask="'+7 ### ###-##-##'"
                                >
                                    <template #messages v-if="$v.phone.$error">
                                        <p v-if="$v.phone.$error && !$v.phone.required">Поле обязательно для заполнения</p>
                                        <p v-if="$v.phone.$error && $v.phone.required && !$v.phone.phoneLength">Проверьте корректность номера</p>
                                        <p v-if="phoneStartsAtEight">Вводите номер телефона с цифры 9</p>
                                    </template>
                                </DInput>
                            </div>
                        </div>
                    </div>

                    <div class="form__group">
                        <div class="_dflex">
                            <DCheckbox
                                v-model="$v.hasPassport.$model"
                                :error="$v.hasPassport.$error"
                            >
                                <p class="p2"><nobr>У меня есть паспорт <br class="_desktop-hidden">гражданина РФ <tooltip text="Подача заявки на карту для лиц, не являющихся гражданами Российской Федерации, осуществляется в отделении Банка"/></nobr></p>
                            </DCheckbox>
                        </div>
                        <p class="form-error" v-if="$v.hasPassport.$error">Для оформления заявки на карту обратитесь в <a href="/location/" class="link">ближайший офис Банка</a></p>
                    </div>
                    <div class="form__group">
                        <DCheckbox
                            v-model="$v.agreement.$model"
                            :error="$v.agreement.$error"
                        >
                            <p class="p2">Я соглашаюсь с <a href="/upload/docs/deposits/Согласие заявителя (ТС по вкладам).docx" target="_blank">условиями использования персональных данных</a>, <a href="/upload/docs/mbanker/Условия предоставления услуг.pdf" target="_blank">условиями предоставления услуги</a> и подтверждаю <a href="/include/mobile-banker/calling/Соглаш. об использ. ПЭП (ТС)_с 25.11.2021.docx" target="_blank">согласие <br class="_mobile-hidden">на использование простой электронной подписи</a></p>
                            <template #messages v-if="$v.agreement.$error">
                                <p v-if="!$v.agreement.$error.required">Поле обязательное для заполнения</p>
                            </template>
                        </DCheckbox>
                    </div>

                    <div class="form__group _dflex _flexwrap-mobile">
                        <DButton @click="tryToSend" id="ym-deposit-step1" class="_mr-24-0 _mb-0-16" :disabled="!stepOneComplete">Продолжить</DButton>
                    </div>

                    <div class="form__lock">
                        <span class="text-small form__lock-text">Мы защищаем ваши персональные данные, не&nbsp;раскрываем их третьим лицам и&nbsp;не&nbsp;распространяем без&nbsp;Вашего согласия на&nbsp;это, если иное не&nbsp;предусмотрено законодательством</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import { cyrWithDash, noSpecSymbol } from '../../assets/js/vue/validations'
    import { required, minLength } from 'vuelidate/lib/validators'
    import { validationMixin } from 'vuelidate'
    import { extractVuelidateErrors } from '../../assets/js/vue/utlis/extractVuelidateErrors';
    import vuelidateMessages from '../../assets/js/vue/validationsMessages';
    import { ESuggestionTypes } from '../../assets/js/vue/utlis/useDadata/utils/ESuggestionTypes'
    import { EFioParts } from '../../assets/js/vue/utlis/useDadata/utils/EFioParts'
    import { DButton } from '@ahml/domrfbank-ui/elements/DButton';
    import { DCheckbox } from '@ahml/domrfbank-ui/elements/DCheckbox';
    import { DInput } from '@ahml/domrfbank-ui/elements/DInput';
    import UiTextInputSuggestions from '../../components-manual/ui/UiTextInputSuggestions.vue';

    let isBetween = require('dayjs/plugin/isBetween')
    dayjs.extend(isBetween);

    export default {
        name: "CardsFormV2Step1",
		components: {
            UiTextInputSuggestions,
            DButton,
            DCheckbox,
            DInput
		},
        mixins: [validationMixin],
        props: {
            isMobile: {
                type: Boolean,
                default: false
            },
        },
        directives: {
            'blur-check': {
                bind: (el, binding, vnode) => {
                    el.addEventListener('blur', () => {
                        let path = el.getAttribute('data-model-path');
                        path = path.split('.').reduce((o,i)=>o[i], vnode.context.$v);
                        path.$touch();
                    })
                },
            },
        },
        data() {
            return {
                lastName: '',
                firstName: '',
                middleName: '',
                hasntMiddleName: false,
                birthDate: '',
                age: {
                    min: {
                        type: 'year',
                        value: 18,
                    },
                    max: {
                        type: 'year',
                        value: 120,
                    }
                },
                phone: '',
                phoneStartsAtEight: false,
                hasPassport: false,
                agreement: false,
                stepOneComplete: false,
                ESuggestionTypes,
                EFioParts,
                sessid: window.config.bitrix_sessid
            }
        },
        validations() {
            return {
                lastName: {
                    required: required,
                    cyrWithDash: cyrWithDash,
                    noSpecSymbol: noSpecSymbol
                },
                firstName: {
                    required: required,
                    cyrWithDash: cyrWithDash,
                    noSpecSymbol: noSpecSymbol
                },
                middleName: {
                    cyrWithDash: cyrWithDash,
                    noSpecSymbol: noSpecSymbol
                },
                birthDate: {
                    required: required,
                    ageRange: (val) => {
                        if (!val) return true;
                        let age = dayjs(this.convertDateToEng(val));
                        let minAge = age.add(this.age.min.value, this.age.min.type);
                        let maxAge = age.add(this.age.max.value, this.age.max.type);

                        return dayjs().isBetween(minAge, maxAge);
                    }
                },
                phone: {
                    required: required,
                    minLength: minLength(16),
                },
                hasPassport: {
                    isAgreed: val => {return val}
                },
                agreement: {
                    isAgreed: val => {return val}
                },
            }
        },
        methods: {
            vuelidateErrorMesages() {
                return extractVuelidateErrors(vuelidateMessages, this.$v).activeErrorMessages;
            },
            stepOneCompleteCheck() {
                if (!this.$v.lastName.$invalid && !this.$v.firstName.$invalid && !this.$v.middleName.$invalid && !this.$v.phone.$invalid && this.agreement && !this.$v.birthDate.$invalid) {
                    this.stepOneComplete = true;
                } else {
                    this.stepOneComplete = false;
                }
            },
            tryToSend() {
                this.$v.lastName.$touch();
                this.$v.firstName.$touch();
                this.$v.middleName.$touch();
                this.$v.phone.$touch();
                this.$v.birthDate.$touch();
                this.$v.hasPassport.$touch();

                if (
                    !this.$v.lastName.$invalid &&
                    !this.$v.firstName.$invalid &&
                    !this.$v.middleName.$invalid &&
                    !this.$v.phone.$invalid &&
                    !this.$v.birthDate.$invalid &&
                    !this.$v.hasPassport.$invalid

                ) {
                    this.sendForm();
                }
            },
            sendForm() {
                this.$emit('setExtraData', this.extraData);
                this.$emit('sendStep', this.formData, 1);
            },
            convertDateToEng(val) {
                return val.replace(/\./g, '-').split('-').reverse().join('-');
            }
        },
        computed: {
            extraData() {
                return {
                    lastName: this.lastName,
                    firstName: this.firstName,
                    birthDate: this.birthDate,
                }
            },
            formData() {
                let data = {
                    data: {
                        type: "debitCard",
                        attributes: {
                            surname: this.lastName,
                            name: this.firstName,
                            middleName: this.middleName,
                            birthdate: this.birthDate,
                            phone: this.phone.replace(/\D/g, ''),
                            agreement: true
                        }
                    }
                }

                return data;
            }
        },
        watch: {
            fio(val) {
                if (val.split(' ').length >= 2) {
                    let fio = val.split(' ');
                    this.lastName = fio[0];
                    this.firstName = fio[1];

                    if (val.split(' ').length === 3) {
                        this.middleName = fio[2];
                    }
                }

                let middleNamePostfix = val.match(/ оглы$| кызы$/i);
                if (middleNamePostfix) {
                    this.middleName = this.middleName + middleNamePostfix[0]
                }

                this.$parent.bank = this.bank;

                this.stepOneCompleteCheck();
            },
            phone() {
                this.stepOneCompleteCheck();
            },
            email() {
                this.stepTwoCompleteCheck();
            },
            agreement(val) {
                this.agreement = val;
                this.stepOneCompleteCheck();
            },
            birthDate() {
                this.stepOneCompleteCheck();
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/scss/base/_variables.scss';
    @import '../../assets/scss/base/_mixins.scss';
    @import '../../assets/scss/base/_functions.scss';

    .form__scope {
        @include mobile {
            border-radius: inherit;
        }
    }

    .form__row, .form__group {
        @include fluid('margin-bottom', 24px);
    }

    .form__col {
        @include mobile {
            @include fluid('margin-bottom', 24px);
        }
    }

    .form__col:last-child {
        @include mobile {
            margin-bottom: 0px;
        }
    }

    .form__split {
        @include fluid('padding-bottom', 24px);
    }
</style>
